var platinSid = PM.CSRFToken;
var platinDateTime = PM.ServerTime;
var platinTimeToken = new Date().getTime();
var platinOrderCountries = PM.Get("Application", "strSIPARIS_ULKELERI");
var platinTcKimlikZorunlu = PM.Get("Application", "x_tc_kimlik_zorunlu");
var platinThemeEnv = PM.Get("AppConfig", "CurrentThemeEnv");

// tüm sayfalar için geçerli
PM.OnPage("*", function () {

	$.validator.methods.email = function (t, e) {
		return this.optional(e) || /^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,}|[0-9]{1,3})(\]?)$/.test(t)
	}

	// Tema önizleme
	if (PM.Get("AppConfig", "ThemePreviewMode") === true) {
		PM.on("ready.platinmarket", function () {
			$.get('/theme/list').then(function (themeList) {
				var currentTheme = themeList.find(function (t) { return t.id === PM.Get("AppConfig", "CurrentSkinFolder").toString(); });
				var previewBar = $('<div class="pm__theme_preview"></div>');
				var buttonStyles = 'padding: 6px 12px; text-align: center; color: #FFF; border-radius: 4px; font-size: 14px; line-height: 16px; font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol !important;';
				var actionButtons = $('<div></div>');
				actionButtons.css({
					'display': 'flex',
					'flex-direction': 'column',
					'justify-content': 'space-around',
					'padding': '10px 20px',
					'padding-right': '30px',
					'background-color': '#444',
					'margin-left': '10px'
				});
				var cancelButton = $('<a style="' + buttonStyles + 'background-color: #dc3545;" href="/main/tema_onizle.asp?c=1">Çıkış</a>');
				var setThemeButton = $('<a style="' + buttonStyles + 'background-color: #007bff;" href="/main/tema_onizle.asp?op=save&i=' + currentTheme.id + '&e=' + currentTheme.env + '">Ayarla</a>');
				actionButtons.append(setThemeButton);
				actionButtons.append(cancelButton);
				var height = 120;
				var gap = 20;
				previewBar.css({
					position: 'fixed',
					top: '0',
					left: '0',
					right: '0',
					'z-index': '9999',
					'background-color': 'rgba(0, 0, 0, .8)',
					height: height.toString() + 'px',
					'box-sizing': 'border-box',
					'transition': 'all ease 200ms',
					'display': 'flex'
				});
				var themeSelector = $('<div class="theme_selector"></div>');
				themeSelector.attr('style', 'overflow-x: scroll; overflow-y: hidden; white-space:nowrap; display: flex; flex: 1 1 auto;');
				themeList.forEach(function (t) {

					if (t.is_public) {
						var node = $('<a data-theme="' + t.id + '" tabindex="-1" href="/main/tema_onizle.asp?i=' + t.id + '&e=' + t.env + '&r=1"></a>');
						var imageNode = $('<img src="' + t.thumbnail + '" />');
						imageNode.css({
							'height': (height - gap).toString() + 'px'
						});
						node.append(imageNode);
						node.css({
							'display': 'block',
							'margin': (gap / 2).toString() + 'px',
							'margin-right': '0px',
							'opacity': '0.3'
						});
						if (t.id === currentTheme.id) {
							node.css({ opacity: '1' });
						}
						node
							.on('mouseenter', function () {
								$(this).css({ opacity: '1' });
							})
							.on('mouseleave', function () {
								if (t.id !== currentTheme.id) $(this).css({ opacity: '0.3' });
							});
						themeSelector.append(node);
					}
				});
				previewBar.append(themeSelector);
				previewBar.append(actionButtons);
				$("body").append(previewBar);
				$("body").css({
					'margin-top': height.toString() + 'px'
				});
				setTimeout(function () {
					$("a[data-theme='" + currentTheme.id + "']").trigger('focus');
				});
			});
		});
	}

	PM.on("ready.platinmarket", function () {

		// SexyLightbox Init
		SexyLightbox.initialize();

		// Load Images
		PM.LoadImages();

		// Load Smart Menu
		if (window.loadSmartMenu) window.loadSmartMenu();

	});

	PM.on("init.platinmarket", function () {

		$("#urun_arama_form").on("submit", function (e) {
			var last_result = $(".ac_results ul li a");
			if (last_result.length === 1) {
				e.preventDefault();
				window.location = last_result[0].href;
			}
		})

		if (document.getElementById('sistem_mesaji') != null) {
			$("#sistem_mesaji").css("top", "-500");
			$("#sistem_mesaji").animate({ "top": "0" }, 400);
			setTimeout('$("#sistem_mesaji").animate({"top" : "-500"},500);', '2000');
			$("#sistem_mesaji a.sistem_mesaji_gizle").on('click', function () {
				$("#sistem_mesaji").animate({ "top": "-500" }, 500);
			});
		}

		if ($("#ust_sepet_kismi a").length > 0) { $("#ust_sepet_kismi a").tipTip({ defaultPosition: "top", delay: 200, fadeIn: 100, fadeOut: 100 }); }
		if ($(".gosterim_secenekleri a").length > 0) { $(".gosterim_secenekleri a").tipTip({ defaultPosition: "bottom", delay: 200, fadeIn: 100, fadeOut: 100 }); }
		if ($(".urun_ikonlar img").length > 0) { $(".urun_ikonlar img").tipTip({ defaultPosition: "top", fadeIn: 100, delay: 200, fadeOut: 100 }); }

		if ($('#ust_uye_panel_ul li').length > 0) {
			$('#ust_uye_panel_ul li').children('div').hide();
			$('#ust_uye_panel_ul li').on('mouseover', function () {
				$(this).children('div').show();
			}).on('mouseout', function () {
				$(this).children('div').hide();
			});
		}

		if (PM.Get("Application", "PlatinCRM_hizmet_arama_iliskilendirme_yonetimi") == "Var") {
			if ($("#urun_arama_input").length > 0) {
				$("#urun_arama_input").autocomplete("/main/aranan_kelimeler.asp?t=" + platinDateTime, {
					delay: 500,
					minChars: 4,
					max: 10,
					scrollHeight: 300,
					selectFirst: false,
					multiple: false,
					matchContains: false,
					mustMatch: false,
					matchCase: true,
					autoFill: false,
					noRecord: false
				}).result(function (e, selectedArr, selected) {
					if (!selected) return;
					var _elem;
					try {
						_elem = $(selected);
						if (_elem && _elem.attr('href')) {
							window.location = _elem.attr('href').trim();
							$(e.target).attr('disabled', 'disabled');
							e.v = _elem.text();
							return;
						}
						if (_elem && _elem.find('span').length) {
							e.v = _elem.find('span').text();
						}
					} catch (err) {
						console.log(err);
						return;
					}

				});
			}
		}

		$("input[name=sid]").each(function () {
			$(this).val(platinSid * 2)
		});
	});

});

//ana sayfa

PM.OnPage("ana_sayfa", function () {

	PM.on("init.platinmarket", function () {

		$("#PM_editorun_secimi ul, #PM_en_cok_izlenen_urun ul, #PM_begenilen_urunler ul").platinCarousel({
			buttons: false,
			prev: function (element) {
				return $(element).parent("div").next("div").children("a.sol_buton");
			},
			next: function (element) {
				return $(element).parent("div").next("div").children("a.sag_buton");
			}
		});

		if (typeof before_lazyload_init == 'function') {
			before_lazyload_init();
		}

		if ($("#vitrin_tabs").length > 0) {

			$('div.urunler').each(function (index2, value2) {
				if ($(this).hasClass("st_tab_view")) $(this).insertAfter(".insert_after");
			});
			$("div.siralama_abbr").tsort("", { order: "asc", attr: "abbr" });
			$(".st_tabs_container").insertBefore(".st_view_container");

			$("body").triggerHandler(new $.Event('slide_tab_load'));

		}

		$('div.urunler').each(function (index2, value2) {
			if (!$(this).hasClass("st_tab_view")) $(this).find("div.urun").equalHeight(function () { $(window).triggerHandler("resize"); });
		});

		if ($("#vitrin_tabs").length > 0) {
			try {

				(function () {
					var ev = new $.Event('fadeIn'), orig = $.fn.fadeIn;
					$.fn.fadeIn = function () {
						var mainArguments = Array.prototype.slice.call(arguments);
						if (!mainArguments[0] && mainArguments.length === 1 && typeof mainArguments[0] != "function") mainArguments[0] = function () { $(this).trigger(ev); };
						if (!mainArguments[1] && typeof mainArguments[1] != "function") mainArguments[1] = function () { $(this).trigger(ev); };
						return orig.apply(this, mainArguments);
					}
				})();

				(function () {
					var tabViewCount = $('div.urunler.st_tab_view').length;
					$('div.urunler.st_tab_view').each(function (index2, value2) {
						$(this).find("div.urun").equalHeight(function () {
							tabViewCount = tabViewCount - 1;
							if (tabViewCount > 0) return;
							$('div#PM_anasayfa_urunler').slideTabs({
								contentAnim: 'fade',
								autoHeight: true,
								autoHeightTime: 100,
								contentAnimTime: 200,
								tabsAnimTime: 200,
								tabsScroll: false
							});
							$(window).triggerHandler("resize");
						});
					});
				})();


			} catch (err) {
				console.error(err);
			}
		}

		$("body").triggerHandler("load_images");
	});
});

// Kategori ürünleri sayfası
PM.OnPage(["urunler", "indirimli_urunler", "arama_sonuclari", "tag", "yeni_urunler"], function () {

	PM.on("init.platinmarket", function () {

		// Daraltmalar
		var selectedOptions = [];
		$(".daraltma").each(function () {
			var sortContainer = $(this);

			// Sort
			var sorterBtn = $("<a href='#' title='Harfe Göre Sırala'></a>");
			sorterBtn.on('click', function (e) {
				e.preventDefault();
				var sortBy = sortContainer.data('sortBy') || 'desc';
				if (!sortContainer.data("sortDataChanged")) {
					PM.emitEvent("before.sort", [sortContainer, sortContainer.find("li")]);
					sortContainer.data("sortDataChanged", true);
				}
				sortContainer.find("li").tsort("label:eq(0)", { order: sortBy, attr: 'title' });
				sortContainer.data('sortBy', sortBy === 'asc' ? 'desc' : 'asc');
			});
			sortContainer.find("p.baslik").append(sorterBtn);
			sorterBtn.tipTip({ defaultPosition: "right", delay: 200, fadeIn: 100, fadeOut: 100 });

			// Scroll
			if (sortContainer.find("li").length > 10) {
				var targetHeight = sortContainer.find("li").toArray().slice(0, 10).reduce(function (b, a) { return typeof b === "object" ? $(b).outerHeight() + $(a).outerHeight() : b + $(a).outerHeight(); });
				if (!!targetHeight && targetHeight > 0) sortContainer.find("ul").css({ 'max-height': targetHeight + 'px', 'overflow-y': 'auto', 'overscroll-behavior': 'contain' });
			}

			// Get selected options
			sortContainer.find("li").toArray().filter(function (el) { return $(el).find("input").length && $(el).find("input")[0].checked; }).forEach(function (_el) { selectedOptions.push({ title: sortContainer.find("p.baslik").attr("data-title"), value: $(_el).attr("data-value"), el: $(_el).find("input")[0] }) });

			// Listen input change
			sortContainer.find("li input[type='checkbox']").on('change', _.debounce(function () {
				$(this).closest("form").find("input").attr("readonly", "readonly");
				$(this).closest("form").trigger('submit');
			}, 250));
		});

		// İşaretli daraltmaları göster
		if (selectedOptions.length) {
			var selectedOptionsTemplate = $($("#selected_options_template").html());
			var removeOptionTemplate = selectedOptionsTemplate.find(".darlatma_secilmis").clone();
			selectedOptionsTemplate.find(".darlatma_secilmis").remove();
			var removeAllOptionTemplate = selectedOptionsTemplate.find(".secimleri_kaldir").clone();
			selectedOptionsTemplate.find(".secimleri_kaldir").remove();
			selectedOptionsTemplate.append(selectedOptions.map(function (s) {
				var _btn = removeOptionTemplate.clone();
				Object.keys(s).forEach(function (k) { _btn.html(_btn.html().replace(new RegExp('%' + k + '%', 'g'), s[k])) });
				_btn.find('a').on('click', function (e) {
					e.preventDefault();
					s.el.checked = false;
					$(s.el).trigger('change');
				}).tipTip({ defaultPosition: "right", delay: 200, fadeIn: 100, fadeOut: 100 });
				return _btn;
			}));
			removeAllOptionTemplate.on('click', function (e) {
				e.preventDefault();
				selectedOptions.forEach(function (s) { s.el.checked = false; $(s.el).trigger('change'); });
			});
			selectedOptionsTemplate.append(removeAllOptionTemplate);
			$('#daraltma_secenkeleri_frm').before(selectedOptionsTemplate);
		}

		if (typeof before_lazyload_init == 'function') {
			before_lazyload_init();
		}

		$(".sizin_icin_sectiklerimiz .urun").equalHeight();
		$(".yeni_urunler .urun").equalHeight();
		$(".indirimli_urunler .urun").equalHeight();
		$(".urunler .urun").equalHeight();
		$(".div.urun_yok_kategoriler_resimli li div").equalHeight();

		$("body").triggerHandler("load_images");

	});
});

// üye giriş sayfası

PM.OnPage("uye_giris", function () {
	PM.on("init.platinmarket", function () {

		$("#uye_giris_email").trigger('focus');

		$("#uye_giris_frm").validate({
			errorLabelContainer: ".uye_giris_hata_mesaji",
			wrapper: "em",
			rules: {
				uye_giris_email: { required: true, email: true },
				uye_giris_sifre: "required"
			},
			messages: {
				uye_giris_email: { required: "Lütfen E-posta adresinizi yazınız.", email: "Geçerli E-posta adresinizi yazınız." },
				uye_giris_sifre: "Lütfen şifrenizi yazınız."
			},
			submitHandler: function (form) {
				$("#uye_giris_submit").prop("disabled", true);
				form.submit();
			}
		});
	});
});

// şifremi unuttum

PM.OnPage("sifremi_unuttum", function () {
	PM.on("init.platinmarket", function () {

		$("#sifremi_unuttum_email").trigger('focus');

		$("#sifremi_unuttum_frm").validate({
			errorLabelContainer: ".sifremi_unuttum_hata_mesaji",
			wrapper: "em",
			rules: {
				sifremi_unuttum_email: { required: true, email: true }
			},
			messages: {
				sifremi_unuttum_email: { required: "Lütfen E-posta adresinizi yazınız.", email: "Geçerli E-posta adresinizi yazınız." }
			},
			submitHandler: function (form) {
				$("#sifremi_unuttum_submit").prop("disabled", true);
				form.submit();
			}
		});
	});
});

// Şifre değiştirme

PM.OnPage("sifre_degistir", function () {
	PM.on("init.platinmarket", function () {
		$("#sifre_degistirme_frm").validate({
			errorElement: "em",
			errorClass: "sifre_degistirme_hata_mesaji",
			errorPlacement: function (error, element) {
				error.appendTo(element.parent("td"));
			},
			submitHandler: function (form) {
				$("#sifre_degistir_btn").prop("disabled", true);
				form.submit();
			},
			rules: {
				uye_eski_sifre: "required",
				uye_yeni_sifre: "required",
				uye_yeni_sifre2: { required: true, equalTo: "#uye_yeni_sifre" }
			},
			messages: {
				uye_eski_sifre: "Lütfen eski şifrenizi yazınız.",
				uye_yeni_sifre: "Lütfen yeni şifrenizi yazınız.",
				uye_yeni_sifre2: { required: "Lütfen yeni şifrenizi tekrar yazınız.", equalTo: "Yeni şifreniz ilk girilenden farklı." }
			}
		});
	});
});

// Üye ol sayfası

PM.OnPage("uye_kayit", function () {

	PM.on("init.platinmarket", function () {

		PM.InitLocationSelector("#uye_ulke", "#uye_il", "#uye_ilce", function () { return true; });

		$("input[name='uye_tip']")
			.on('change', () => $(".kurumsal_uyelik_tr")[$("input[name='uye_tip']:checked").val() === "2" ? 'show' : 'hide']())
			.trigger('change');

		$("#uye_kayit_frm").validate({
			errorElement: "em",
			errorClass: "uye_kayit_hata_mesaji",
			showErrors: function (errorMap, errorList) {
				if (_.find(errorList, function (o) { return o.element.name == "uye_sozlesmesi" }) && errorList.length === 1) {
					return alert("Üye olmak için sözleşmeyi kabul etmeniz gerekmektedir.");
				}
				this.defaultShowErrors();
			},
			errorPlacement: function (error, element) {
				error.appendTo(element.parent("td"));
			},
			submitHandler: function (form) {
				$("#uye_kayit_btn").prop("disabled", true);
				var params = {};
				$("#uye_kayit_frm").serializeArray().forEach(function (e) { params[e.name] = e.value });
				PM.emitEvent("new.user", [params]);
				return true;
			},
			rules: {
				uye_firma_unvani: { required: { depends: PM.depends("input[name='uye_tip']:checked", 2) } },
				uye_firma_vd: { required: { depends: PM.depends("input[name='uye_tip']:checked", 2) } },
				uye_firma_vn: { required: { depends: PM.depends("input[name='uye_tip']:checked", 2) } },
				uye_sozlesmesi: { checked: true },
				uye_ad: { required: true },
				uye_soyad: { required: true },
				uye_mail: { required: true, email: true, remote: "/scripts/uye_mail_kontrol.asp?sid=" + platinSid },
				uye_tel: { required: false, Telefon: true },
				uye_sifre: { required: true },
				uye_sifre2: { required: true, equalTo: "#uye_sifre" },
				uye_gsm: {
					required: {
						depends: function () {
							return $("#uye_gsm").length > 0;
						}
					}, gsm: true
				}
			},
			messages: {
				uye_firma_unvani: "Lütfen firma unvanını yazınız.",
				uye_firma_vd: "Lütfen vergi dairesini yazınız.",
				uye_firma_vn: "Lütfen vergi numarası yazınız.",
				uye_sozlesmesi: "Lütfen sözleşmeyi kabul ediniz.",
				uye_ad: "Lütfen isminizi yazınız.",
				uye_soyad: "Lütfen soyisminizi yazınız.",
				uye_mail: { required: "Lütfen e-posta'nızı yazınız.", email: "Geçerli e-posta'nızı yazınız.", remote: "E-posta sistemde kayıtlı." },
				uye_tel: "Lütfen telefon numaranızı kontrol ediniz.",
				uye_gsm: "Lütfen gsm numaranızı başında sıfır olmadan giriniz",
				uye_sifre: "Lütfen şifrenizi yazınız.",
				uye_sifre2: { required: "Şifrenizi tekrar yazınız.", equalTo: "Şifreniz ilk girilenden farklı." }
			}
		});

	});
});

// Üyelik bilgileri düzenleme

PM.OnPage("uye_bilgileri", function () {
	PM.on("init.platinmarket", function () {

		PM.InitLocationSelector("#uye_ulke", "#uye_il", "#uye_ilce", function () { return true; });

		$("input[name='uye_tip']")
			.on('change', () => $(".kurumsal_uyelik_tr")[$("input[name='uye_tip']:checked").val() === "2" ? 'show' : 'hide']())
			.trigger('change');

		$("#uye_bilgileri_frm").validate({
			errorElement: "em",
			errorClass: "uye_bilgileri_hata_mesaji",
			errorPlacement: function (error, element) {
				error.appendTo(element.parent("td"));
			},
			submitHandler: function (form) {
				$("#uye_bilgileri_degistir_btn").prop("disabled", true);
				return true;
			},
			rules: {
				uye_firma_unvani: { required: { depends: PM.depends("input[name='uye_tip']:checked", 2) } },
				uye_firma_vd: { required: { depends: PM.depends("input[name='uye_tip']:checked", 2) } },
				uye_firma_vn: { required: { depends: PM.depends("input[name='uye_tip']:checked", 2) } },
				uye_ad: { required: true },
				uye_soyad: { required: true },
				uye_listeye_katil: { checked: false }
			},
			messages: {
				uye_firma_unvani: "Lütfen firma unvanını yazınız.",
				uye_firma_vd: "Lütfen vergi dairesini yazınız.",
				uye_firma_vn: "Lütfen vergi numarası yazınız.",
				uye_ad: "Lütfen isminizi yazınız.",
				uye_soyad: "Lütfen soyisminizi yazınız."
			}
		});
	});
});

// adres bilgileri gösterim

PM.OnPage("adres_bilgileri", function () {
	PM.on("init.platinmarket", function () {

		$("#yeni_teslimat_adres").on('click', function () {
			SexyLightbox.show('', '/adres-bilgileri-ekle?tip=1&TB_iframe=true&height=600&width=600&modal=1', '', '');
		});

		$("#yeni_fatura_adres").on('click', function () {
			SexyLightbox.show('', '/adres-bilgileri-ekle?tip=2&TB_iframe=true&height=600&width=600&modal=1', '', '');
		});

		$("#liste_tumunu_sec").on('click', function () {
			var checked_status = this.checked;
			$("input[name=liste_sec]").each(function () {
				this.checked = checked_status;
				if ($(this).is(':checked')) {
					$(this).parent().parent().addClass('secili');
				} else {
					$(this).parent().parent().removeClass('secili');
				}
			});
		});

		$("#teslimat_listeden_cikart_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				if (confirm('Seçili teslimat adreslerini listeden çıkarmak istediğinizden eminmisiniz?')) {
					$("input[name=islem]").val("teslimat_adresi_secili_sil");
					$("#teslimat_adres_frm").trigger('submit');
					this.disabled = "disabled";
				}
			}
		});

		$("#teslimat_listeyi_bosalt_btn").on('click', function () {
			if (confirm('Teslimat Adresleri listesini boşaltmak istediğinizden eminmisiniz?')) {
				$("input[name=islem]").val("teslimat_adresi_listesi_bosalt");
				$("#teslimat_adres_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});


		$("#fatura_listeden_cikart_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				if (confirm('Seçili fatura adreslerini listeden çıkarmak istediğinizden eminmisiniz?')) {
					$("input[name=islem]").val("fatura_adresi_secili_sil");
					$("#fatura_adres_frm").trigger('submit');
					this.disabled = "disabled";
				}
			}
		});

		$("#fatura_listeyi_bosalt_btn").on('click', function () {
			if (confirm('Fatura Adresleri listesini boşaltmak istediğinizden eminmisiniz?')) {
				$("input[name=islem]").val("fatura_adresi_listesi_bosalt");
				$("#fatura_adres_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("input[name=liste_sec]").on('click', function () {
			if ($(this).is(':checked')) {
				$(this).parent().parent().addClass('secili');
			} else {
				$(this).parent().parent().removeClass('secili');
			}
		});
	});
});

// Adres ekle/düzenle
PM.OnPage(["fatura_adresi_ekle", "fatura_adresi_duzenle", "teslimat_adresi_ekle", "teslimat_adresi_duzenle"], function () {

	PM.on("init.platinmarket", function () {

		if (PM.Get("Application", "x_tc_kimlik_zorunlu") == 2) $(".tc_kimlik").attr("style", "display:none !important;");

		PM.InitLocationSelector("#ulke", "#il", "#ilce");

		PM.on("set.adres.fatura", function (rules) {
			$("form")
				.on("selected.bireysel", function () {
					$(".kurumsal_fatura_tr").hide();
					$(".bireysel_fatura_tr").show();
				})
				.on("selected.kurumsal", function () {
					$(".kurumsal_fatura_tr").show();
					$(".bireysel_fatura_tr").hide();
				});
			$("form [name='fatura_tip']").on("change", function () {
				var selected = $("form [name='fatura_tip']:checked")[0];
				selected.value == "1" ? $("form").triggerHandler(new $.Event("selected.bireysel")) : $("form").triggerHandler(new $.Event("selected.kurumsal"));
				$("form [name='fatura_tip']").data("value", (selected.value == "1" ? "bireysel" : "kurumsal"));
			}).triggerHandler("change");
		});

		$("form").validate(PM.ValidationOptions(["fatura_adresi_ekle", "fatura_adresi_duzenle"].indexOf(PM.ActionPage) > -1 ? "adres.fatura" : "adres"));

	});
});

// müşteri hizmetleri

PM.OnPage("musteri_hizmetleri", function () {

	PM.on("init.platinmarket", function () {

		$("#PM_Musteri_Hizmetleri_Menu_UL").treeview({
			animated: "fast",
			collapsed: false,
			persist: "cookie"
		});

		$("#musteri_hizmetleri_iletisim_form").validate({
			errorElement: "em",
			errorClass: "musteri_hizmetleri_iletisim_hata_mesaji",
			errorPlacement: function (error, element) {
				error.appendTo(element.parent("td"));
			},
			submitHandler: function (form) {
				$("#iletisim_gonder_btn").prop("disabled", true);
				return true;
			},
			showErrors: function (errorMap, errorList) {
				if (_.find(errorList, function (o) { return o.element.name == "gizlilik_politikasi_onay" }) && errorList.length === 1) {
					return alert('Lütfen "Gizlilik Politikasını" onayladığınızı belirten kutucuğu işaretleyiniz.');
				}
				this.defaultShowErrors();
			},
			rules: {
				iletisim_isim: "required",
				gizlilik_politikasi_onay: { checked: true },
				iletisim_email: { required: true, email: true },
				iletisim_tel: { required: true, Telefon: true },
				iletisim_mesaj: "required"
			},
			messages: {
				iletisim_isim: "Lütfen isminizi yazınız.",
				gizlilik_politikasi_onay: "Devam etmek için gizlilik politikasını kabul etmeniz gerekiyor.",
				iletisim_email: { required: "Lütfen e-posta'nızı yazınız.", email: "Geçerli e-posta'nızı yazınız." },
				iletisim_tel: { required: "Lütfen irtibat telefonu yazınız." },
				iletisim_mesaj: "Lütfen boş geçmeyiniz."
			}
		});
	});
});

// ürün detayı
PM.OnPage("urun_detay", function () {

	PM.on("init.platinmarket", function () {

		// Photoswipe Init
		const lightboxEvent = new $.Event('before-init-lightbox');
		PM.emitEvent(lightboxEvent.type, [lightboxEvent]);
		if (PM.IsMobile()) lightboxEvent.preventDefault(); // Deprecated code
		if (!lightboxEvent.isDefaultPrevented() && typeof PhotoSwipe !== 'undefined' && $("a[rel^='lightbox']").length) {
			const photoSwipeContainer = $(`<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
				<div class="pswp__bg"></div>
				<div class="pswp__scroll-wrap">
					<div class="pswp__container">
						<div class="pswp__item"></div>
						<div class="pswp__item"></div>
						<div class="pswp__item"></div>
					</div>
					<div class="pswp__ui pswp__ui--hidden">
						<div class="pswp__top-bar">
							<div class="pswp__counter"></div>
							<button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
							<button class="pswp__button pswp__button--share" title="Share"></button>
							<button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
							<button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
							<div class="pswp__preloader">
								<div class="pswp__preloader__icn">
								<div class="pswp__preloader__cut">
									<div class="pswp__preloader__donut"></div>
								</div>
								</div>
							</div>
						</div>
						<div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
							<div class="pswp__share-tooltip"></div>
						</div>
						<button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
						</button>
						<button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
						</button>
						<div class="pswp__caption">
							<div class="pswp__caption__center"></div>
						</div>
					</div>
				</div>
			</div>`)[0];
			$('body').append(photoSwipeContainer);
			$("a[rel^='lightbox']").on('click', function (e) {
				e.preventDefault();
				const target = $("a[rel='" + $(this).attr('rel') + "']");
				const currIndex = target.toArray().indexOf(this);
				const items = $("a[rel='" + $(this).attr('rel') + "']").toArray().map(el => Object.assign({
					src: $(el).attr('href') === "javascript:void(0);" ? $(el).find('img').attr('src') : $(el).attr('href'),
					w: 0,
					h: 0,
					title: $("h1.urun_ismi").text()
				}));
				const options = PM.Get("Configure", "Lightbox") || {}
				options['index'] = currIndex;
				const lightbox = new PhotoSwipe(photoSwipeContainer, PhotoSwipeUI_Default, items, options);
				lightbox.listen('gettingData', function (index, item) {
					if (item.w === 0 && item.h === 0) {
						var img = new Image();
						img.onload = function () {
							item.w = this.width;
							item.h = this.height;
							lightbox.updateSize(true);
						};
						img.src = item.src;
					}
				});
				lightbox.init();
			})
		}

		$("div.urun_onerileri ul").platinCarousel({ group: 4 });

		$("div.urun_detay_sol div.urun_resmi a").css("display", "block").css("visibility", "hidden").css("position", "absolute");
		$("div.urun_detay_sol div.urun_resmi a:first").css("visibility", "visible");
		$("div.urun_detay_sol div.urun_resmi").css("overflow", "visible");

		PM.SetDefault('Configure', 'JqZoom.zoomWidth', $("div.urun_detay_sol div.urun_resmi").width());
		PM.SetDefault('Configure', 'JqZoom.zoomHeight', $("div.urun_detay_sol div.urun_resmi").height());
		PM.SetDefault('Configure', 'JqZoom.xOffset', $("div.urun_detay_sol div.urun_resmi").width() - $("div.urun_detay_sol div.urun_resmi a").width());

		if (['reverse', 'standart'].indexOf(PM.Get('Configure', 'JqZoom.zoomType')) > -1)
			PM.SetDefault('Configure', 'JqZoom.yOffset', ($("div.urun_detay_sol div.urun_resmi a").height() - $("div.urun_detay_sol div.urun_resmi").height()) / 2);

		// Trigger event for before-init-jq-zoom
		var jqzoomEvent = new $.Event('before-init-jq-zoom');
		PM.emitEvent(jqzoomEvent.type, [jqzoomEvent]);
		if (!jqzoomEvent.isDefaultPrevented()) $("div.urun_detay_sol div.urun_resmi a.buyutec").jqzoom(PM.Get('Configure', 'JqZoom'));

		$("div.uyeye_ozel_kampanya_bar").animate({
			"height": "toggle",
			"opacity": "toggle"
		}, { duration: 500 }
		);

		// Yeni Urun Secenekleri Baslangic

		// Alt ürün seçim kutusu
		$("select[name=alt_urun_secenekleri]").on('change', function () {
			// Trigger event for goto variant
			var goVariantEvent = new $.Event('before-go-variant');
			goVariantEvent.subProductId = $(this).val();
			if (!goVariantEvent.subProductId) return;
			goVariantEvent.subProductLink = window.location.pathname.replace(/^\/(.*)-pmu([0-9]+).*/, "\/$1-pmu$2?variant=" + goVariantEvent.subProductId.toString());
			PM.emitEvent(goVariantEvent.type, [goVariantEvent]);
			$("input[name='alt_urun_id']").val(goVariantEvent.subProductId);
			if (!goVariantEvent.isDefaultPrevented()) window.location = goVariantEvent.subProductLink;
		});

		// Aşamalı seçim kutusu
		var variantMap = [];
		$("select[name=urun_secenekleri]")
			.each(function (i) {
				//if (i !== 0 && !this.value) $(this).attr("disabled", "disabled");
				variantMap.push({
					el: this,
					options: $(this).find("option[value]").toArray()
						.filter(function (f) { return !!f.value; })
						.map(function (f) {
							var matris = [];
							eval("matris = " + $(f).attr("data-matris"));
							return { el: f, matris: matris };
						})
				});
			})
			.on("change", function (e, cont) {
				cont = typeof cont === "undefined" ? true : cont;

				var selectEl = this;
				// Get current select
				var currentSelectIndex = variantMap.findIndex(function (s) { return s.el === selectEl; });
				var currentOptionIndex = variantMap[currentSelectIndex].options.findIndex(function (o) { return o.el.value === selectEl.value; });

				// Ger current matris
				var currentMatris = (currentOptionIndex > -1 ? variantMap[currentSelectIndex].options[currentOptionIndex].matris : []);

				// Set value "" next select
				variantMap.slice(currentSelectIndex + 1, currentSelectIndex + 2).forEach(function (s) {
					if (cont) s.el.value = "";
					$(s.el).prop('disabled', currentOptionIndex === -1);
					s.options.forEach(function (o) {
						$(o.el).prop('disabled', currentMatris.findIndex(function (c) { return c[2] > 0 && c[1].indexOf(parseInt(o.el.value, 10)) > -1; }) === -1);
					});
				});

				if (!cont) return;

				// Generate result
				var result = variantMap.map(function (v) { return !!v.el.value ? parseInt(v.el.value, 10) : undefined }).filter(function (v) { return !!v });

				if (result.length !== variantMap.length) return;
				var subProductId;
				variantMap.forEach(function (v) { v.options.forEach(function (o) { o.matris.forEach(function (m) { if (JSON.stringify(m[1].sort()) === JSON.stringify(result.sort())) subProductId = m[0]; }); }); });

				if (!subProductId) return;

				// Trigger event for goto variant
				var goVariantEvent = new $.Event('before-go-variant');
				goVariantEvent.subProductId = subProductId;
				goVariantEvent.subProductLink = window.location.pathname.replace(/^\/(.*)-pmu([0-9]+).*/, "\/$1-pmu$2?variant=" + subProductId.toString());
				PM.emitEvent(goVariantEvent.type, [goVariantEvent]);
				$("input[name='alt_urun_id']").val(subProductId);
				if (!goVariantEvent.isDefaultPrevented()) {
					window.history.replaceState(null, null, goVariantEvent.subProductLink);
					window.location = goVariantEvent.subProductLink;
				}

			}).toArray().reverse().forEach(function (e) { $(e).trigger("change", false); });

		if (variantMap.length) {
			variantMap[0].options.forEach(function (o) {
				if (!o.matris.filter(function (m) { return m[2] > 0; }).length) $(o.el).attr("disabled", "disabled");
			});
		}

		// Yeni Urun Secenekleri Bitiis

		$("ul.urun_detay_tablar_ul li:first").addClass("active").show();
		$(".tab_content").hide();
		$(".tab_content:first").show();
		$("ul.urun_detay_tablar_ul li").on('click', function () { PM_Tab(this); });

		function PM_Tab(tab_id) {
			if (!$(tab_id).hasClass("active")) PM.emitEvent("view.tab", [$(tab_id).text().trim().replace(/\(.*\)/, "").trim()]);
			var tabim_id = tab_id;
			$("ul.urun_detay_tablar_ul li").removeClass("active");
			$(tabim_id).addClass("active");
			$(".tab_content").hide();
			var activeTab = $(tabim_id).find("a").attr("rel");
			$(activeTab).show();
			$("div.urun_onerileri ul").css({ "position": "static" });
			$("div.urun_onerileri ul").css({ "position": "relative" });
			return false;
		}

		$("div.urun_taksit_secenekleri_kisa a").on('click', function () { PM_Tab($("div.urun_taksit_secenekleri_kisa")); $("ul.urun_detay_tablar_ul li a.link_3").parent().addClass("active"); });

		$('div.urun_oy').rater('/scripts/urune_oy_ver.asp?islem=urune_oy_ver&sid=' + platinSid + '&urun_id=' + $("#urun_id").val(), { style: 'basic', curvalue: $('#urun_detay_suanki_oy').val(), active: $('#urun_oy_durumu').val() });

		// Küçük resimler
		$("div.urun_resmi_kucuk img").on('mouseenter', function () {
			const target = this;
			$("div.urun_detay_sol div.urun_resmi a").each(function () {
				$(this).css('visibility', $(this).hasClass(target.id) ? 'visible' : 'hidden');
			});
			$('div.urun_resmi_kucuk img').each(function () {
				target !== this ? $(this).removeClass("secili").css('opacity', .7) : $(this).addClass("secili").css('opacity', 1);
			});
		}).first().triggerHandler('mouseenter');
		if ($(".urun_resmi_kucuk").length != 0) $(".urun_resmi_kucuk").slideByMouse({ scanOffset: 50 });

		// Sepete ekleme formu validate
		$("#urun_detay_sepete_ekle_form").validate({
			errorLabelContainer: ".miktar_hatali",
			rules: {
				urun_miktar_secenekleri: {
					required: true,
					number: true,
					min: parseInt($('#urun_min_miktar').val(), 10),
					max: parseInt($('#urun_max_miktar').val(), 10)
				}
			},
			submitHandler: function () {

				// Seçilen kampanyalar
				$("#kampanya_idleri").val($("input[name=kampanyadan_yararlan]:checked").toArray().map(el => $(el).val()).join(','));

				// Varyasyonlar
				const variationSelector = $("select[name=urun_secenekleri], select[name=alt_urun_secenekleri]");
				const allVariationsSelected = !variationSelector.length ? true : (variationSelector.toArray().filter(el => $(el).val() === '').length === 0);

				// Varyasonlar seçildimi
				if (!allVariationsSelected) {
					alert('Bu işlemi yapabilmek için ürün seçeneklerini belirleyin.');
					return false;
				}

				// Trigger before event
				const e = $.Event("before_add_to_cart");
				if ($("body").triggerHandler(e) === false) return false;

				// Trigger after event
				const params = {};
				$("#urun_detay_sepete_ekle_form").serializeArray().forEach(function (e) { params[e.name] = e.value; });
				PM.emitEvent("add.cart", [params]);

				// Devam
				return true;
			},
			messages: {
				urun_miktar_secenekleri: {
					required: "Lütfen rakam girin.",
					number: "Lütfen rakam girin.",
					min: "Miktar en az " + $('#urun_min_miktar').val() + " " + $('label[for=urun_miktar_secenekleri]').html() + " olmalı.",
					max: "En fazla " + $('#urun_max_miktar').val() + " " + $('label[for=urun_miktar_secenekleri]').html() + " olabilir."
				}
			}
		});

		// Sepete ekle button
		$("#sepete_ekle_buton").on('click', function () {
			$("#urun_detay_sepete_ekle_form input[name=islem]").val("sepete_ekle");
			$("#urun_detay_sepete_ekle_form").trigger('submit');
		});

		// Hemen al button
		$("#hemenal_buton").on('click', function () {
			$("#urun_detay_sepete_ekle_form input[name=islem]").val(PM.Get("Session", "sepetteki_urun_adedi") > 0 ? "hizli_satin_al_beraber" : "hizli_satin_al_tek");
			$("#urun_detay_sepete_ekle_form").trigger('submit');
		});

		$(".urun_ozeelik_aciklama").tipTip({ defaultPosition: "right", maxWidth: '250px', delay: 200, fadeIn: 100, fadeOut: 100 });
		$(".urun_paylas_butonlar a").tipTip({ defaultPosition: "top", delay: 200, fadeIn: 100, fadeOut: 100 });

		$("#teklif_iste_frm").validate({
			errorElement: "em",
			errorClass: "teklif_iste_hata_mesaji",
			errorPlacement: function (error, element) {
				error.appendTo(element.parent("td"));
			},
			submitHandler: function (form) {
				$("#teklif_iste_btn").prop("disabled", true);
				return true;
			},
			rules: {
				teklif_iste_isim: "required",
				teklif_iste_email: { required: true, email: true },
				teklif_iste_tel: { required: true, Telefon: true },
				teklif_iste_sayi: {
					required: true,
					number: true,
					min: parseInt($('#min_teklif_isteme_miktari').val(), 10),
					max: parseInt($('#max_teklif_isteme_miktari').val(), 10)
				}
			},
			messages: {
				teklif_iste_isim: "Lütfen isminizi yazınız.",
				teklif_iste_email: { required: "Lütfen e-posta'nızı yazınız.", email: "Geçerli e-posta'nızı yazınız." },
				teklif_iste_tel: { required: "Lütfen irtibat telefonu yazınız." },
				teklif_iste_sayi: {
					required: "Lütfen miktar giriniz.",
					number: "Lütfen miktar giriniz.",
					min: "Miktar en az " + $('#min_teklif_isteme_miktari').val() + " olmalı.",
					max: "Miktar çok fazla."
				}
			}
		});

		$("div.urun_kampanyalari input[name=kampanyadan_yararlan]").each(function () {
			if ($(this).prop('checked')) {
				$(this).parent().parent().addClass('secili');
			}
		});

		$("div.urun_kampanyalari input[name=kampanyadan_yararlan]").on('click', function () {
			if ($(this).prop('checked')) {
				$(this).parent().parent().addClass('secili');
			} else {
				$(this).parent().parent().removeClass('secili');
			}
		});

		$("div.facebook_begen_buton").html('<div><div style="float:right;width:95px;overflow:hidden;"><iframe loading="lazy" src="//www.facebook.com/plugins/like.php?app_id=193538460704254&amp;href=' + encodeURI(document.location) + '&amp;send=false&amp;layout=button_count&amp;width=450&amp;show_faces=true&amp;action=like&amp;colorscheme=light&amp;font&amp;height=21" scrolling="no" frameborder="0" style="border:none; overflow:hidden; width:450px; height:21px;" allowTransparency="true"></iframe></div><div style="clear:left;"></div></div>');

		$("body").triggerHandler("load_images");

	});
});

// alışveriş listesi

PM.OnPage("alisveris_listesi", function () {
	PM.on("init.platinmarket", function () {
		$("#liste_tumunu_sec").on('click', function () {
			var checked_status = this.checked;
			$("input[name=liste_sec]").each(function () {
				this.checked = checked_status;
				if ($(this).is(':checked')) {
					$(this).parent().parent().addClass('secili');
				} else {
					$(this).parent().parent().removeClass('secili');
				}
			});
		});

		$("#listeden_cikart_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				$("input[name=islem]").val("alisveris_listesi_secili_sil");
				$("#alisveris_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("#sepete_ekle_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				$("input[name=islem]").val("listeler_sepete_ekle");
				$("#alisveris_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("#listeyi_bosalt_btn").on('click', function () {
			if (confirm('Alışveriş Listenizi boşaltmak istediğinizden eminmisiniz?')) {
				$("input[name=islem]").val("alisveris_listesi_bosalt");
				$("#alisveris_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("input[name=liste_sec]").on('click', function () {
			if ($(this).is(':checked')) {
				$(this).parent().parent().addClass('secili');
			} else {
				$(this).parent().parent().removeClass('secili');
			}
		});
	});
});

// fiyat alarm listesi

PM.OnPage("fiyat_alarm_listesi", function () {
	PM.on("init.platinmarket", function () {
		$("#liste_tumunu_sec").on('click', function () {
			var checked_status = this.checked;
			$("input[name=liste_sec]").each(function () {
				this.checked = checked_status;
				if ($(this).is(':checked')) {
					$(this).parent().parent().addClass('secili');
				} else {
					$(this).parent().parent().removeClass('secili');
				}
			});
		});

		$("#listeden_cikart_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				if (confirm('Seçili ürünleri Fiyat Alarm Listenizden çıkartmak istediğinizden eminmisiniz?')) {
					$("input[name=islem]").val("fiyat_alarm_listesi_secili_sil");
					$("#fiyat_alarm_listesi_frm").trigger('submit');
					this.disabled = "disabled";
				}
			}
		});

		$("#sepete_ekle_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				$("input[name=islem]").val("listeler_sepete_ekle");
				$("#fiyat_alarm_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("#listeyi_bosalt_btn").on('click', function () {
			if (confirm('Fiyat Alarm Listenizi boşaltmak istediğinizden eminmisiniz?')) {
				$("input[name=islem]").val("fiyat_alarm_listesi_bosalt");
				$("#fiyat_alarm_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("input[name=liste_sec]").on('click', function () {
			if ($(this).is(':checked')) {
				$(this).parent().parent().addClass('secili');
			} else {
				$(this).parent().parent().removeClass('secili');
			}
		});
	});
});

// kıyaslama listesi

PM.OnPage("kiyaslama_listesi", function () {
	PM.on("init.platinmarket", function () {

		$("#liste_tumunu_sec").on('click', function () {
			var checked_status = this.checked;
			$("input[name=liste_sec]").each(function () {
				this.checked = checked_status;
				if ($(this).is(':checked')) {
					$(this).parent().parent().addClass('secili');
				} else {
					$(this).parent().parent().removeClass('secili');
				}
			});
		});

		$("#listeden_cikart_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				$("input[name=islem]").val("kiyaslama_listesi_secili_sil");
				$("#kiyaslama_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("#sepete_ekle_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				$("input[name=islem]").val("listeler_sepete_ekle");
				$("#kiyaslama_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("#listeyi_bosalt_btn").on('click', function () {
			if (confirm('Kıyaslama Listenizi boşaltmak istediğinizden eminmisiniz?')) {
				$("input[name=islem]").val("kiyaslama_listesi_bosalt");
				$("#kiyaslama_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("input[name=liste_sec]").on('click', function () {
			if ($(this).is(':checked')) {
				$(this).parent().parent().addClass('secili');
			} else {
				$(this).parent().parent().removeClass('secili');
			}
		});

		$("#urunleri_kiyasla_btn").on('click', function () {
			var secilmismi = 0;
			var secili_urun_idler = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = secilmismi + 1;
					if (secili_urun_idler == "") {
						secili_urun_idler = $("#liste_urun_id_" + $(this).val()).val();
					} else {
						secili_urun_idler = secili_urun_idler + "," + $("#liste_urun_id_" + $(this).val()).val();
					}
				}
			});
			if (secilmismi < 2) {
				alert('Kıyaslama işlemi yapabilmek için en az 2 ürün seçmelisiniz.');
			} else {

				if ($(window).width() > 1399) {
					var ekran_genisligi = 1350;
				} else {
					var ekran_genisligi = $(window).width() - 50;
				}
				var ekran_yuksekligi = $(window).height() - 100;
				var secili_grup_idim = $("#kiyas_urun_tipi").val();
				var linkim = "/secili-urunleri-kiyasla?gid=" + secili_grup_idim + "&uid=" + secili_urun_idler + "&TB_iframe=true&height=" + ekran_yuksekligi + "&width=" + ekran_genisligi + "&modal=1"
				SexyLightbox.show('', linkim, '', '');
			}
		});

	});
});

// stok alarm listesi

PM.OnPage("stok_alarm_listesi", function () {
	PM.on("init.platinmarket", function () {
		$("#liste_tumunu_sec").on('click', function () {
			var checked_status = this.checked;
			$("input[name=liste_sec]").each(function () {
				this.checked = checked_status;
				if ($(this).is(':checked')) {
					$(this).parent().parent().addClass('secili');
				} else {
					$(this).parent().parent().removeClass('secili');
				}
			});
		});

		$("#listeden_cikart_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				$("input[name=islem]").val("stok_alarm_listesi_secili_sil");
				$("#stok_alarm_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("#sepete_ekle_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				$("input[name=islem]").val("listeler_sepete_ekle");
				$("#stok_alarm_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("#listeyi_bosalt_btn").on('click', function () {
			if (confirm('Stok Alarm Listenizi boşaltmak istediğinizden eminmisiniz?')) {
				$("input[name=islem]").val("stok_alarm_listesi_bosalt");
				$("#stok_alarm_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("input[name=liste_sec]").on('click', function () {
			if ($(this).is(':checked')) {
				$(this).parent().parent().addClass('secili');
			} else {
				$(this).parent().parent().removeClass('secili');
			}
		});
	});
});

// alışveriş puanlarım

PM.OnPage("puanlarim", function () {
	PM.on("init.platinmarket", function () {
		$("#liste_tumunu_sec").on('click', function () {
			var checked_status = this.checked;
			$("input[name=liste_sec]").each(function () {
				if ($(this).attr("disabled") != true) {
					this.checked = checked_status;
					if ($(this).is(':checked')) {
						$(this).parent().parent().addClass('secili');
					} else {
						$(this).parent().parent().removeClass('secili');
					}
				}
			});
		});

		$("input[name=liste_sec]").on('click', function () {
			if ($(this).attr("disabled") != true) {
				if ($(this).is(':checked')) {
					$(this).parent().parent().addClass('secili');
				} else {
					$(this).parent().parent().removeClass('secili');
				}
			}
		});

		$("#cek_yap_btn").on('click', function () {
			var secilmismi = 0;
			var secili_puan_idler = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = secilmismi + 1;
				}
			});
			if (secilmismi < 1) {
				alert('Puanlarınızı çeke dönüştürebilmek için enaz 1 adet aktif puan seçmeniz gerekiyor.');
			} else {
				if (confirm('Seçtiğiniz puanlarınızı çeke dönüştürmek istediğinizden eminmisiniz?')) {
					$("#puanlarim_frm input[name=islem]").val("puanlarimi_ceke_donustur");
					$("#puanlarim_frm").trigger('submit');
					$(this).prop("disabled", true);
				}
			}
		});
	});
});

// bildirimler

PM.OnPage("bildirimler", function () {

	PM.on("init.platinmarket", function () {

		$("#bildirim_listesi a").on('click', function () {
			$(this).parent().parent().removeClass('okunmadi');
			var okunmamis_mesaj = $("#bildirimler_link span").html();
			if (okunmamis_mesaj > 0) {
				$("#bildirimler_link span").html(okunmamis_mesaj - 1);
			}
		});

		$("#liste_tumunu_sec").on('click', function () {
			var checked_status = this.checked;
			$("input[name=liste_sec]").each(function () {
				this.checked = checked_status;
				if ($(this).is(':checked')) {
					$(this).parent().parent().addClass('secili');
				} else {
					$(this).parent().parent().removeClass('secili');
				}
			});
		});

		$("#listeden_cikart_btn").on('click', function () {
			var secilmismi = "";
			$("input[name=liste_sec]").each(function () {
				if (this.checked == true) {
					secilmismi = "evet";
					return false;
				}
			});
			if (secilmismi != "evet") {
				alert('Bu işlemi yapabilmek için seçim yapmalısınız.');
			} else {
				if (confirm('Seçili bildirimleri silmek istediğinizden eminmisiniz?')) {
					$("input[name=islem]").val("bildirim_listesi_secili_sil");
					$("#bildirim_listesi_frm").trigger('submit');
					this.disabled = "disabled";
				}
			}
		});

		$("#listeyi_bosalt_btn").on('click', function () {
			if (confirm('Bildirim Kutusunu boşaltmak istediğinizden eminmisiniz?')) {
				$("input[name=islem]").val("bildirim_listesi_bosalt");
				$("#bildirim_listesi_frm").trigger('submit');
				this.disabled = "disabled";
			}
		});

		$("input[name=liste_sec]").on('click', function () {
			if ($(this).is(':checked')) {
				$(this).parent().parent().addClass('secili');
			} else {
				$(this).parent().parent().removeClass('secili');
			}
		});
	});
});

// takip sistemi talepler

PM.OnPage("takip_sistemi", function () {
	PM.on("init.platinmarket", function () {

		$("#yeni_talep").on('click', function () {
			SexyLightbox.show('', '/ariza-iade-talep-ekle?TB_iframe=true&height=330&width=400&modal=1', '', '');
		});

	});
});

// takip sistemi talep ekleme

PM.OnPage("talep_ekle", function () {

	PM.on("init.platinmarket", function () {

		$("#talep_kaydet").validate({
			errorElement: "em",
			errorClass: "talep_ekle_hata_mesaji",
			rules: {
				konu: "required",
				aciklama: "required"
			},
			messages: {
				konu: "*",
				aciklama: "*"
			},
			submitHandler: function (form) {
				$("#talep_kaydet_submit").prop("disabled", true);
				form.submit();
			}
		});
	});
});

// takip sistemi talep detayı

PM.OnPage("talep_goster", function () {
	PM.on("init.platinmarket", function () {

		$("#talep_ekle").validate({
			errorLabelContainer: ".talep_ekle_hata_mesaji",
			wrapper: "em",
			rules: {
				cevap: "required"
			},
			messages: {
				cevap: "Lütfen cevap yazınız."
			},
			submitHandler: function (form) {
				$("#talep_ekle_submit").prop("disabled", true);
				form.submit();
			}
		});
	});
});

// satıcıya danışma

PM.OnPage("saticiya_danis", function () {
	PM.on("init.platinmarket", function () {

		$("#saticiya_danis_frm").validate({
			errorLabelContainer: ".saticiya_danis_hata_mesaji",
			wrapper: "em",
			rules: {
				soru: "required"
			},
			messages: {
				soru: "Lütfen sorunuzu yazınız."
			},
			submitHandler: function (form) {
				$("#saticiya_danis_submit").prop("disabled", true);
				form.submit();
			}
		});
	});
});

// sepet detayı

PM.OnPage("sepet_detayi", function () {

	PM.on("init.platinmarket", function () {

		$("div.sepet_oneriler_bu_urunleri_gordunuzmu_icerik ul").platinCarousel({
			buttons: false,
			prev: function (element) {
				return $(element).parent("div").next("div").children("a.sol_buton");
			},
			next: function (element) {
				return $(element).parent("div").next("div").children("a.sag_buton");
			}
		});

		$("#hediye_ceklerim_goster").on('click', function () {
			SexyLightbox.show('', '/aktif-ceklerim?tip=1&TB_iframe=true&height=500&width=600&modal=1', '', '');
		});

		ceki_sepete_gonder = function (cek_kodu) {
			if (cek_kodu != '') {
				$("#cek_no").val(cek_kodu);
				SexyLightbox.close();
			}
		}

		$("#cekler_frm").on('submit', function (e) {
			if ($("#cek_no").val().trim() != '') {
				$("#cekler_frm input[name=islem]").val("sepette_cek_kullan");
				$("#cek_kullan").prop("disabled", true);
			} else {
				e.preventDefault();
				alert('Lütfen kod giriniz.');
				$("#cek_no").trigger('focus');
			}
		});

		$("#sepet_urun_sil_tumunu_sec").on('click', function () {
			if ($(this).attr("rel") != "tumunu_sectim") {
				$(this).attr("rel", "tumunu_sectim");
				$("input.sepet_urun_sil").prop("checked", true);
				$("input.sepet_urun_sil").parent().parent().addClass('secili');
			} else {
				$(this).removeAttr("rel");
				$("input.sepet_urun_sil").prop('checked', false);
				$("input.sepet_urun_sil").parent().parent().removeClass('secili');
			}
		});

		// Get New & Deleted products
		function productFromCartRow(tr) {
			var product = {};
			var targetNode = $(tr).find(".urun_isim_kampanya > a:eq(0)");
			product["id"] = targetNode.attr("href").replace(/.*pmu([0-9]+)/i, "$1");
			product["name"] = targetNode.attr("title");
			return product;
		}
		$("input#birim").toArray().forEach(function (el) { $(el).attr("data-orginal-value", $(el).val()); });

		$("#sepeti_guncelle").on('click', function () {
			// Get New & Deleted products
			var toDeleteProducts = $("input.sepet_urun_sil").toArray().filter(function (el) { return el.checked; }).map(function (el) {
				return Object.assign(productFromCartRow($(el).closest("tr")[0]), { quantity: parseInt($(el).closest("tr").find("input#birim").attr("data-orginal-value"), 10) });
			});
			$("input.sepet_urun_sil").toArray().filter(function (el) { return !el.checked; }).map(function (el) { return $(el).closest("tr").find("input#birim")[0]; }).filter(function (el) { return parseInt($(el).val(), 10) < parseInt($(el).attr("data-orginal-value"), 10); }).forEach(function (el) {
				toDeleteProducts.push(Object.assign(productFromCartRow($(el).closest("tr")[0]), { quantity: parseInt($(el).attr("data-orginal-value"), 10) - parseInt($(el).val(), 10) }));
			});
			var addToCart = $("input.sepet_urun_sil").toArray().filter(function (el) { return !el.checked; }).map(function (el) { return $(el).closest("tr").find("input#birim")[0]; }).filter(function (el) { return parseInt($(el).val(), 10) > parseInt($(el).attr("data-orginal-value"), 10); }).map(function (el) {
				return Object.assign(productFromCartRow($(el).closest("tr")[0]), { quantity: parseInt($(el).val(), 10) - parseInt($(el).attr("data-orginal-value"), 10) });
			});
			if (toDeleteProducts.length) toDeleteProducts.forEach(function (p) { PM.emitEvent("remove.cart", [p]); });
			if (addToCart.length) addToCart.forEach(function (p) { PM.emitEvent("add.cart", [p]); });

			$("input[name=islem]").val("sepet_detayi_guncelle");
			$("#sepet_frm").trigger('submit');
			$(this).prop("disabled", true);

		});

		$("input.sepet_urun_sil").on('click', function () {
			if ($(this).is(':checked')) {
				$(this).parent().parent().addClass('secili');
			} else {
				$(this).parent().parent().removeClass('secili');
			}
		});

		$("div.kampanya_yazisi").each(function () {
			var kampanya_icerigim = $(this).text();
			$(this).attr("title", kampanya_icerigim);
		});

		$(".kampanya_yazisi").tipTip({ maxWidth: 'auto', defaultPosition: "top", delay: 200, maxWidth: '390px', fadeIn: 100, fadeOut: 100, content: $(this).children("div").html() });

		$("#satin_al").on('click', function () {
			window.location.href = '/uye-teslimat-ve-fatura-bilgileri?sid=' + platinSid;
		});

		$("body").triggerHandler("load_images");

	});
});

// Yorum yap
PM.OnPage("yorum_yap", function () {
	$("#yorum_yap_form").on("submit", function (e) {
		if (!$("#yorum_aciklama").val().trim()) {
			alert('Lütfen yorumunuzu yazınız.');
			$("#yorum_aciklama").trigger('focus');
			return e.preventDefault();
		}
		$("#gonder").prop("disabled", true);
	});
});

// Sipariş Takibi
PM.OnPage("siparis_takibi", function () {
	PM.on("init.platinmarket", function () {
		$("#siparis_takibi_frm").validate({
			errorElement: "em",
			errorClass: "siparis_takibi_hata_mesaji",
			errorPlacement: function (error, element) {
				error.appendTo(element.parent("td"));
			},
			submitHandler: function (form) {
				$("#siparis_takibi_btn").prop("disabled", true);
				form.submit();
			},
			rules: {
				siparis_no: "required",
				siparis_email: { required: true, email: true }
			},
			messages: {
				siparis_no: "Lütfen siparis numaranızı yazınız.",
				siparis_email: { required: "Lütfen e-posta'nızı yazınız.", email: "Geçerli e-posta'nızı yazınız." }
			}
		});
	});
});

// teslimat fatura bilgileri order step 1

PM.OnPage("order_step_1", function () {

	PM.on("init.platinmarket", function () {

		// Location selector
		PM.InitLocationSelector("#teslimat_ulke", "#teslimat_sehir", "#teslimat_ilce").then(PM.InitLocationSelector.bind(PM, "#fatura_ulke", "#fatura_sehir", "#fatura_ilce"));

		// Set Address autocomplete
		$("#teslimat_tanim, #fatura_tanim").each(function () {
			var _type = this.id.replace("_tanim", "");
			var _cache_key = PM.Get("AppConfig", "AssetCacheKey");
			var _url = "/main/teslimat_fatura_tanim_bul.asp?ref=" + _type + "&_t=" + _cache_key;
			$(this)
				.autocomplete(_url, $.extend(PM.Get("Configure", "Autocomplate"), {
					formatItem: function (r) { return r[1] + r[2]; },
					formatResult: function (r) { return r[1].replace(/(<.+?>)/gi, ''); }
				}))
				.result(function (e, data) {
					$("div." + _type + "_bilgileri div.icerik")
						.animate({ opacity: .1 }, 100)
						.promise()
						.done(function () {
							var _container = this;
							PM.Ajax("/main/teslimat_fatura_form_getir.asp?_t=" + _cache_key, { tanim_id: data[0], tanim_tip: _type, sid: PM.CSRFToken })
								.then(function (_values) {
									var nodes = $();
									$(_values).find("PM_Form_Eleman").each(function () {
										var node;
										if (node = $("#" + this.id)[0]) nodes = nodes.add($(node).set($(this).children().text()));
									});
									nodes.trigger("change");
									return Promise.resolve();
								})
								.then($.fn.animate.bind($(_container), { opacity: 1 }, 100));
						});
				})
				.on('focus', function () {
					$(this).trigger('click');
				});
		});

		// Set readonly if user logged in
		if (PM.Get("Session", "member_login") == "true") $("#konuk_ad, #konuk_soyad, #konuk_email").readOnly();

		// Before Form Set Validation Rules
		PM.on("set.teslimat_fatura_bilgileri._base", function (rules) {
			_.forEach(rules.rules, function (rule, name) {
				rules.messages[name] = "&nbsp;"
			});
		});

		function _mask_tel(e) {
			var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,2})(\d{0,2})/);
			e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + (x[4] ? x[3] + '-' + x[4] : x[3]) : '');
		}

		// Form Related Events
		$("form")
			// On All Change Events
			.on("change", function () {
				if (PM.Get("Application", "x_tc_kimlik_zorunlu") == 2)
					$(".teslimat_tc_kimlik, .fatura_tc_kimlik").attr("style", "display:none !important;");
				else
					$(".teslimat_tc_kimlik")[$(this).data("same_invoice_data") ? "show" : "hide"]();
				$("#dock")
					.css({ "min-height": $("div.siparis_sayfasi_icerik_sol").height() })
					.find("div.dock_icerik").css({ "min-height": $("#dock").height() });
			})
			// Same Invoice Data
			.data("same_invoice_data", !$("input[name='faturam_teslimat_bilgilerim_farkli']").checked())
			.on("change.invoice.same_data", function (e) {
				$(this).find(".fatura_bilgileri")[$(this).data("same_invoice_data") ? "hide" : "show"]();
			})
			.on("change", "input[name='faturam_teslimat_bilgilerim_farkli']", function (e) {
				const checked = $(e.target).checked();

				if (checked == false) $(e.target).removeAttr("checked");

				$(e.delegateTarget)
					.data("same_invoice_data", checked == false)
					.trigger("change.invoice.same_data");
			})
			.on("change", "select[name='teslimat_ulke']", function (e) {
				const targets = $("#teslimat_tel, #teslimat_gsm, #fatura_tel, #fatura_gsm");
				if (this.value === 'Türkiye') {
					targets.on('input', _mask_tel);
				} else {
					targets.off('input', _mask_tel);
				}
				//$("#teslimat_tel, #teslimat_gsm, #fatura_tel, #fatura_gsm")[$(this).closest("form").find("[name='teslimat_ulke']")[0].value === 'Türkiye' ? 'mask' : 'unmask']("(999) 999-99-99");

			})
			// Send With Order
			.data("invoice_with_order", $("input[name='faturam_siparisimle_gelsin']").checked())
			.on("change.invoice.send_with_order", function (e) {
				$(this).find("span.faturam_ayri_adrese_ucret")[$(this).data("invoice_with_order") ? "hide" : "show"]();
			})
			.on("change", "input[name='faturam_siparisimle_gelsin']", function (e) {
				$(e.delegateTarget)
					.data("invoice_with_order", $(e.target).checked())
					.trigger("change.invoice.send_with_order");
			})
			// Invoice Type
			.data("invoice_type", $("#fatura_tip").val() == "1" ? "bireysel" : "kurumsal")
			.on("change.invoice.type", function (e) {
				var _type = $(this).data("invoice_type");
				if (_type == "bireysel") {
					$(".kurumsal_fatura_tr").hide().find("input").val("");
					$(".bireysel_fatura_tr").show();
					return;
				}
				$(".kurumsal_fatura_tr").show();
				$(".bireysel_fatura_tr").hide().find("input").val("");
			})
			.on("change", "#fatura_tip", function (e) {
				$(e.delegateTarget)
					.data("invoice_type", $("#fatura_tip").val() == "1" ? "bireysel" : "kurumsal")
					.trigger("change.invoice.type");
			})
			// Submit Form
			.on("click", "#sonraki_adim", function (e) {
				$(e.delegateTarget).trigger('submit');
			})
			// Trigger the whole form
			.trigger("change")
			// Validate
			.validate(PM.ValidationOptions({
				errorClass: "adres_hata_mesaji",
				showErrors: function (errorMap, errorList) {
					if (_.find(errorList, function (o) { return o.element.name == "gizlilik_politikasi_onay" }) && errorList.length === 1) {
						return alert('Lütfen "Gizlilik Politikasını" onayladığınızı belirten kutucuğu işaretleyiniz.');
					}
					this.defaultShowErrors();
				},

				submitHandler: function (form) {
					var params = {};
					$(form).serializeArray().forEach(function (p) { params[p.name] = p.value; });
					PM.emitEvent("process.checkout", [params]);
					return true;
				},
				onsubmit: true,
				onfocusout: false,
				onkeyup: false,
				onclick: false
			}, "teslimat_fatura_bilgileri"));

		// Keep Session Open
		PM.KeepSession();

		$("#konuk_ad").on('blur', function () {
			if (!$("#teslimat_ad").val()) $("#teslimat_ad").val($("#konuk_ad").val());
		}).trigger("blur");
		$("#konuk_soyad").on('blur', function () {
			if (!$("#teslimat_soyad").val()) $("#teslimat_soyad").val($("#konuk_soyad").val());
		}).trigger("blur");

		$("div.kampanya_yazisi")
			.each(function () { $(this).attr("title", $(this).text()); })
			.tipTip({ maxWidth: 'auto', defaultPosition: "top", delay: 200, maxWidth: '270px', fadeIn: 100, fadeOut: 100, content: $(this).children("div").html() });
		$("#dock li")
			.on('mouseenter', function () {
				$(this).find("div").stop(true, true).animate({ right: $("#dock").width() }, 200).show("fast", function () { $(this).parent("li").addClass("active"); });
			})
			.on('mouseleave', function () {
				$(this).find("div").stop(true, true).animate({ right: $("#dock").width() }, 200).hide(0, function () { $(this).parent("li").removeClass("active"); });
			});
	});
	// Deprecated code end
});

// kargo ve ödeme seçenekleri order step 2

PM.OnPage("order_step_2", function () {

	// Deprecated code start
	const _bankSel = $("#taksit_seceneklerim_icerik_kredi_karti_select");
	const selectedBank = $("input[name='kk_banka_secimi']").val() || null;
	if (selectedBank) _bankSel.val(selectedBank).prepend(_bankSel.find('option:selected'));
	// Deprecated code end

	PM.on("init.platinmarket", function () {

		PM.KeepSession();

		// Ödeme tipi mapper
		const odeme_tipi_mapper = {
			"kredi_karti": "os_kredi_karti",
			"kapida_odeme": "os_kapipda_odeme",
			"havale_eft": "os_havale",
			"paycell": "os_paycell",
			"custom": "os_custom",
			"stripe": "os_stripe",
			"iyzico_pwi": "os_iyzico_pwi"
		};

		// Targets
		const installmentCnt = $('div.taksit_seceneklerim_icerik_taksit_sayisi div.banka_taksit_secenekleri'); // Taksit seçme container
		const bankSel = $("#taksit_seceneklerim_icerik_kredi_karti_select"); // Banka seçimi

		// Generate initial state
		const currState = window.currState = new Statr({
			odeme_tipi: $("input[name='sot']").val() ? Object.keys(odeme_tipi_mapper).find(k => $("input[name='sot']").val() === odeme_tipi_mapper[k]) : null,
		});
		if (currState.get('odeme_tipi')) currState.set(currState.get('odeme_tipi') + ".kargo_firmasi", parseFloat($("input[name='kargo_secimi']").val()) || null);
		currState.set("kredi_karti.odeme_sekli", parseFloat($("input[name='kk_odeme_tipi_secimi']").val()) || null);
		currState.set("kredi_karti.banka", $("input[name='kk_banka_secimi']").val() || null);
		currState.set("kredi_karti.taksit", parseFloat($("input[name='taksit_id']").val()) || null);
		currState.set("kapida_odeme.odeme_sekli", parseFloat($("input[name='kapida_odeme_tipi_secimi']").val()) || null);
		currState.set("havale_eft.odeme_sekli", parseFloat($("input[name='hvl_eft_banka_secimi']").val()) || null);

		// Taksit tablosu getirici
		const taksit_getir = function () {
			// Check variables
			if (!currState.get('kredi_karti.banka') || !currState.get('kredi_karti.kargo_ucret')) return;

			// Installment selector disable
			bankSel.addClass('yukleniyor').prop('disabled', true);

			// Load data
			$.when(installmentCnt.stop().fadeTo(100, .07))
				.then(() => new Promise((r) => installmentCnt.load('/main/order_step2_taksit_secenekleri.asp?' + "t=" + platinTimeToken + "&sid=" + platinSid + "&banka_id=" + currState.get('kredi_karti.banka') + "&kf=" + currState.get('kredi_karti.kargo_ucret'), r)))
				.then(() => $.when(installmentCnt.stop().fadeTo(100, 1)))
				.then(() => {
					bankSel.removeClass('yukleniyor').prop('disabled', false);
					// Taksit seçici
					const selectedVal = currState.get('kredi_karti.taksit');
					const items = $("div.taksit_seceneklerim_icerik_taksit_sayisi table tr.taksitler").listSelector({
						value: 'value',
						activeClass: 'secili',
						change: currState.connect('kredi_karti.taksit', (_, i) => currState.set('kredi_karti.taksit_ucret', i[1].data('ucret').toString()))
					}).toArray();
					const selectedItem = items.find(i => i[0] === selectedVal);
					if (!!selectedItem) selectedItem[1].trigger('click');
				});
		};

		// Kredi kartı taksit seçimi
		currState.on('kredi_karti.taksit_ucret', (n, o) => {
			if (!currState.get('kredi_karti.taksit_ucret')) return;
			if (currState.get('odeme_tipi') === 'kredi_karti' && currState.get('kredi_karti.odeme_sekli') === 2) $("div.son_tutar_div span").html(currState.get('kredi_karti.taksit_ucret') + "&nbsp;" + $("#vpb").val());
		});

		// Kredi kartı ödeme şekli değişirse
		currState.on('kredi_karti.odeme_sekli', (n, o) => {
			// Purge cache
			if (n !== o && o === 2) currHash = '';

			// Açıklamalar

			$("#taksit_seceneklerim")[n === 2 ? 'show' : 'hide']();
			$("#kredi_karti_aciklama")[n === 3 ? 'hide' : 'show']();
			$("#garantipay_aciklama")[n === 4 ? 'show' : 'hide']();

			// Taksit
			currState.set('kredi_karti.taksit_ucret', currState.get('kredi_karti.taksit_ucret'));
		})


		// Taksit ücreti değişirse
		currState.on('kredi_karti.kargo_ucret', (n, o) => {
			if (n === o) return;
			if (!!currState.get('kredi_karti.banka')) taksit_getir();
		});

		// Seçili banka değişirse
		currState.on('kredi_karti.banka', (n, o) => {
			if (n === o) return;
			taksit_getir();
		});

		// Kapıda ödeme şekli nakit & kredi kartı
		currState.on('kapida_odeme.kapida_odeme_sekli', (n, o) => {
			setTimeout(() => {
				const items = $("ul.odeme_secenekleri_tablar_ul li").tabSelector('kapida_odeme')[2].find(".odeme_secimi table tr").listSelector('all');
				[1, 2].indexOf(n) > -1 ? items.forEach(i => i[1][i[0] === n ? 'show' : 'hide']()) : items.forEach(i => i[1].show());
				const selectedItem = items.find(i => !!i[2]);
				if (!selectedItem || (!!selectedItem && selectedItem[0] !== n) && n !== 3) items.slice(0).find(i => i[0] === n || n === 3)[1].trigger('click');
			});
		});

		let currHash;
		currState.on('change', (n, o) => {
			const odeme_tipi = currState.get('odeme_tipi');
			const odeme_sekli = currState.get('kredi_karti.odeme_sekli');
			const kargo_ucreti = currState.get(odeme_tipi + '.kargo_ucret');
			const para_birimi = $("#vpb").val();

			// Set form data
			$("input[name='sot']").val(odeme_tipi_mapper[odeme_tipi]); // Ödeme Tipi
			$("input[name='kargo_secimi']").val(currState.get(odeme_tipi + '.kargo_firmasi')); // Kargo Firması
			$("input[name='kk_banka_secimi']").val(currState.get('kredi_karti.banka')); // Kredi kartı banka
			$("input[name='kk_odeme_tipi_secimi']").val(currState.get('kredi_karti.odeme_sekli')); // Kredi kartı ödeme şekli
			$("input[name='taksit_id']").val(currState.get('kredi_karti.taksit')); // Kredi kartı taksit sayısı
			$("input[name='kapida_odeme_tipi_secimi']").val(currState.get('kapida_odeme.odeme_sekli')); // Kapıda ödeme şekli
			$("input[name='hvl_eft_banka_secimi']").val(currState.get('havale_eft.odeme_sekli')); // Havale banka seçimi

			// Check current hash
			if (!odeme_tipi || !kargo_ucreti || currHash === odeme_tipi + '' + kargo_ucreti) return;
			currHash = odeme_tipi + '' + kargo_ucreti;

			// Kredi kartı taksitli
			if (odeme_tipi === 'kredi_karti' && odeme_sekli === 2) return;

			// Son tutar
			$("div.son_tutar_div span")
				.load('/main/order_step2_son_odeme_hesapla.asp?t=' + platinTimeToken + '&sid=' + platinSid + '&ot=' + odeme_tipi + '&kf=' + kargo_ucreti + '&pb=' + para_birimi);
		});

		// Ödeme seçeneği seçici
		$("ul.odeme_secenekleri_tablar_ul li")
			.tabSelector({
				value: 'value',
				selected: currState.get('odeme_tipi'),
				change: currState.connect('odeme_tipi')
			})
			.toArray()
			.forEach((tab) => {

				// Kargo firma seçimi
				tab[2].find(".kargo_secimi table tr:not('.kargo_yok')")
					.listSelector({
						value: 'value',
						selected: currState.get(tab[0] + '.kargo_firmasi'),
						activeClass: 'secili',
						change: currState.connect(tab[0] + '.kargo_firmasi', (_, i) => {
							currState.set(tab[0] + '.kargo_ucret', i[1].data('ucret').toString());
							currState.set(tab[0] + '.kapida_odeme_sekli', i[1].data('kapidaOdeme'));
						})
					});

				// Ödeme şekli seçimi
				tab[2].find(".odeme_secimi table tr")
					.listSelector({
						value: 'value',
						selected: currState.get(tab[0] + '.odeme_sekli'),
						activeClass: 'secili',
						change: currState.connect(tab[0] + '.odeme_sekli')
					});

			});
		// Banka seçici
		if (currState.get('kredi_karti.banka')) bankSel.val(currState.get('kredi_karti.banka'));
		bankSel.on('change', () => currState.set('kredi_karti.banka', bankSel.val())).trigger('change');

		// Form post
		if (PM.Get('Application', 'skip_order_summary')) {

			on_bilgilendirme_modal = function () {
				if (platinThemeEnv === "mobile") {
					var s_w = $(window).width();
					var s_h = $(window).height();
					var linkim_siparisi_tamamla = "/main/on_bilgilendirme_formu.asp?t=" + platinDateTime + "&sid=" + platinSid + "&height=" + s_h + "&width=" + s_w + "&modal=1"
				} else {
					var linkim_siparisi_tamamla = "/main/on_bilgilendirme_formu.asp?t=" + platinDateTime + "&sid=" + platinSid + "&height=600&width=800&modal=1"
				}
				SexyLightbox.show('Ön Bilgilendirme Formu', linkim_siparisi_tamamla, '', '');
			};

			satis_sozlesmesi_modal = function () {
				if (platinThemeEnv === "mobile") {
					var s_w = $(window).width();
					var s_h = $(window).height();
					var linkim_siparisi_tamamla2 = "/main/satis_sozlesmesi.asp?t=" + platinDateTime + "&sid=" + platinSid + "&height=" + s_h + "&width=" + s_w + "&modal=1"
				} else {
					var linkim_siparisi_tamamla2 = "/main/satis_sozlesmesi.asp?t=" + platinDateTime + "&sid=" + platinSid + "&height=600&width=800&modal=1"
				}
				SexyLightbox.show('Mesafeli Satış Sözleşmesi', linkim_siparisi_tamamla2, '', '');
			};

			odeme_sayfasi = function () {
				var linkim_siparisi_tamamla_hepsi = "/main/order_mask.asp?t=" + platinDateTime + "&TB_iframe=true&height=500&width=500&modal=1"
				SexyLightbox.show('', linkim_siparisi_tamamla_hepsi, '', '');
			};


			sozleseye_ekle = function (eklenecek_data) {
				if (eklenecek_data == 'kargo_firmasi') {
					$("#sozlesme_kargo_firmasi").html($($("div.odeme_secenekleri_tablar .active").attr("data-tab-target")).find('.secili').find('.kargo_td_3').text());
				} else if (eklenecek_data == 'kargo_ucreti') {

					$("#sozlesme_kargo_ucreti").html($($("div.odeme_secenekleri_tablar .active").attr("data-tab-target")).find('.secili').find('.kargo_td_4').text());

				} else if (eklenecek_data == 'odeme_tipi') {
					var odeme_tipim_yazi = $("div.odeme_secenekleri_tablar .active").text();
					$("#sozlesme_odeme_tipi").html(odeme_tipim_yazi);
				}
			}

			$("#sonraki_adim").on('click', (e) => {
				e.preventDefault();
				if (platinThemeEnv !== "mobile") {
					if ($("#sozlesme_kabul").prop("checked") == false) {
						alert('Devam etmek için ön bilgilendirme ve satış sözleşmesini kabul etmeniz gerekiyor.');
					} else {
						$("#odeme_kargo_secenekleri_frm").trigger('submit');
					}
				}

			});

		} else {

			$("#sonraki_adim").on('click', (e) => {
				e.preventDefault();
				$("#odeme_kargo_secenekleri_frm").trigger('submit');
			});

		}





	});
});

// sipariş onayı order step 3

PM.OnPage("order_step_3", function () {

	PM.on("init.platinmarket", function () {

		PM.KeepSession();

		on_bilgilendirme_modal = function () {
			if (platinThemeEnv === "mobile") {
				var s_w = $(window).width();
				var s_h = $(window).height();
				var linkim_siparisi_tamamla = "/main/on_bilgilendirme_formu.asp?t=" + platinDateTime + "&sid=" + platinSid + "&height=" + s_h + "&width=" + s_w + "&modal=1"
			} else {
				var linkim_siparisi_tamamla = "/main/on_bilgilendirme_formu.asp?t=" + platinDateTime + "&sid=" + platinSid + "&height=500&width=800&modal=1"
			}
			SexyLightbox.show('', linkim_siparisi_tamamla, '', '');
		};

		satis_sozlesmesi_modal = function () {
			if (platinThemeEnv === "mobile") {
				var s_w = $(window).width();
				var s_h = $(window).height();
				var linkim_siparisi_tamamla2 = "/main/satis_sozlesmesi.asp?t=" + platinDateTime + "&sid=" + platinSid + "&height=" + s_h + "&width=" + s_w + "&modal=1"
			} else {
				var linkim_siparisi_tamamla2 = "/main/satis_sozlesmesi.asp?t=" + platinDateTime + "&sid=" + platinSid + "&height=500&width=800&modal=1"
			}
			SexyLightbox.show('', linkim_siparisi_tamamla2, '', '');
		};

		$("#siparisi_tamamla").on('click', function () {
			if (platinThemeEnv !== "mobile") {
				if ($("#sozlesme_kabul").prop("checked") == false) {
					alert('Devam etmek için ön bilgilendirme ve satış sözleşmesini kabul etmeniz gerekiyor.');
				} else {
					odeme_sayfasi();
					PM.emitEvent("process.checkout", []);
				}
			}
		});

		odeme_sayfasi = function () {
			var linkim = "/main/order_mask.asp?t=" + platinDateTime + "&TB_iframe=true&height=500&width=800&modal=1";
			SexyLightbox.show('', linkim, '', '');
		};

		sozleseye_ekle = function (eklenecek_data) {
			if (eklenecek_data == 'urunler') {
				sozlesme_urunlerim = '<table cellpadding="0" cellspacing="0"><tr><th align="left">Ürün İsmi</th><th align="center">Miktar</th><th align="right">Kdv Dahil Birim Fiyatı</th></tr>'
				$("#sepet_detay_mini div.urun").each(function () {
					sozlesme_urunlerim = sozlesme_urunlerim + '<tr>'
					if ($(this).find("span.alt_urun").length > 0) {
						sozlesme_urunlerim = sozlesme_urunlerim + '<td align="left">' + $(this).find("div.urun_isim").text() + '<br/>' + $(this).find("span.alt_urun").text() + '</td>'
					} else {
						sozlesme_urunlerim = sozlesme_urunlerim + '<td align="left">' + $(this).find("div.urun_isim").text() + '</td>'
					}
					sozlesme_urunlerim = sozlesme_urunlerim + '<td align="center">' + $(this).find("div.urun_fiyat").html().split("&nbsp;X&nbsp;")[1] + '</td>'
					sozlesme_urunlerim = sozlesme_urunlerim + '<td align="right">' + $(this).find("input.urun_fiyat_kdv_dahil").val() + '</td>'
					sozlesme_urunlerim = sozlesme_urunlerim + '</tr>'
				});
				sozlesme_urunlerim = sozlesme_urunlerim + '</table>'
				$("#sozlesme_siparis_urunleri").html(sozlesme_urunlerim);
			} else if (eklenecek_data == 'kargo_firmasi') {
				$("#sozlesme_kargo_firmasi").html($("div.siparis_onayi_odeme_bilgilerim_icerik").find("tr.kargo_firmasi").find("td.deger").text());
			} else if (eklenecek_data == 'kargo_ucreti') {
				if ($("div.sepet_son_toplamalar").find("tr.kargo_ucreti").find("td.deger").text().indexOf("Alıcı Ödemeli") > -1) {
					$("#sozlesme_kargo_ucreti").html("Alıcı Ödemeli");
				} else if ($("div.sepet_son_toplamalar").find("tr.kargo_ucreti").find("td.baslik").text().indexOf("Kapıda Ödeme") > -1) {
					$("#sozlesme_kargo_ucreti").html("(Kapıda Ödeme) " + $("div.sepet_son_toplamalar").find("tr.kargo_ucreti").find("td.deger").text());
				} else {
					$("#sozlesme_kargo_ucreti").html($("div.sepet_son_toplamalar").find("tr.kargo_ucreti").find("td.deger").text());
				}
			} else if (eklenecek_data == 'odeme_tipi') {
				var odeme_tipim_yazi = $("div.siparis_onayi_odeme_bilgilerim_icerik").find("tr.odeme_tipi").find("td.deger").text();
				if ($("div.siparis_onayi_odeme_bilgilerim_icerik").find("tr.odeme_tipi").attr("rel")) {
					odeme_tipim_yazi = odeme_tipim_yazi + " (" + $("div.siparis_onayi_odeme_bilgilerim_icerik").find("tr.odeme_tipi").attr("rel").replace("-", "&nbsp;") + ")";
				}
				$("#sozlesme_odeme_tipi").html(odeme_tipim_yazi);
			}
		}

	});
});

/** Sanal Pos */
PM.OnPage("sanalpos", function () {
	PM.on("init.platinmarket", function () {
		// Credit cart validator
		if ($('#sanalpos_odeme_form input#pan').length) {
			$('#sanalpos_odeme_form input#pan').validateCreditCard(function (result) {
				// Set flags
				$(this)
					.data('is_valid', result.valid && result.length_valid && result.luhn_valid)
					.data('card_type', !!result && !!result.card_type ? result.card_type.name : undefined);
				// Activate type class
				var activeType = !!result && !!result.card_type ? result.card_type.name : undefined;
				if (!activeType) $('ul.cards li').not('.off').addClass('off');
				if (!!activeType && $('ul.cards li.' + activeType).length && $('ul.cards li.' + activeType + '.off').length) {
					$('ul.cards li').not('.off').addClass('off');
					$('ul.cards li.' + activeType + '.off').removeClass('off');
				}
			});
		}

		// Add to validator
		$.validator.addMethod("cc_card", function (_, element) { return $(element).data('is_valid'); }, 'Geçersiz kart numarası');

		// Pay form validation
		$("#sanalpos_odeme_form:not([data-validate='false'])").validate(PM.ValidationOptions({
			errorElement: "span",
			validClass: "success",
			submitHandler: function (form) {
				$("#kredi_karti_gonder_btn").attr("disabled", "disabled").val('Lütfen Bekleyin');
				return true;
			},
			rules: {
				pan: {
					required: true,
					digits: true,
					cc_card: true
				},
				cardOwner: {
					required: true
				},
				cv2: {
					required: true,
					digits: true,
					maxlength: 4,
					minlength: 3
				}
			},
			messages: {
				pan: {
					required: "Boş bırakılmaz",
					digits: "Yanlızca rakam içermeli",
					cc_card: "Geçersiz kart numarası"
				},
				cardOwner: {
					required: "Boş bırakılmaz"
				},
				cv2: {
					required: "Boş bırakılmaz",
					digits: "Yanlızca rakam içermeli",
					maxlength: "En fazla 4 hane olmalı",
					minlength: "En az 3 hane olmalı"
				}
			}
		}));

		// Joker vadaa query
		if ($("#koim_varmi").val() == "1") {
			$("#jokerim").hide();
			$('.pan').on('change', function () {
				var joker_time = new Date().getTime();
				$.ajax({
					url: 'ykb_joker_vadaa_sorgula.asp?sid=' + joker_time + '&ccno=' + $(".pan").val(),
					success: function (data) {
						if (data.trim() != "") {
							$('#jokerim').html(data).show();
							parent.SexyLightbox.resize(630, $("body").height() + $("#jokerim").innerHeight());
						} else {
							$('#jokerim').hide();
						}
					}
				});
			}).triggerHandler('change');
		}
	});
});
